import { useQuery } from "react-query";
import { getEventMaterials } from "../../../services/api/eventMaterials";
import { getMaterial, getMaterials } from "../../../services/api/materials";
import { Options } from "../utils/types";

export const MATERIAL_SINGLE_QUERY_KEY = "Q_MATERIAL_SINGLE";

export const useMaterial = (id: number) => {
  return useQuery([MATERIAL_SINGLE_QUERY_KEY, id], () => getMaterial(id));
};
